import type { IconProps } from "./icon-types";

/**
 * 해(sun). Light 테마 표시/토글 등에서 사용.
 *
 * sigmakit-gui는 `react-icons/md`의 `MdLightMode`를 쓰지만, c6 아이콘 세트 톤·크기 통일을 위해
 * 동일 의미의 `react-icons/lu` `LuSun`(Lucide `sun`)을 인라인으로 재현 —
 * c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘). 24 그리드 / stroke 기반.
 */
export const SunIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2" />
    <path d="M12 20v2" />
    <path d="m4.93 4.93 1.41 1.41" />
    <path d="m17.66 17.66 1.41 1.41" />
    <path d="M2 12h2" />
    <path d="M20 12h2" />
    <path d="m6.34 17.66-1.41 1.41" />
    <path d="m19.07 4.93-1.41 1.41" />
  </svg>
);
